module.exports = __webpack_public_path__ + "static/media/f-fb.c7fb451c.svg";